import {
  ACTION_GET_AGENCIES,
  ACTION_GET_AGENCIES_SUCCESS,
  ACTION_GET_AGENCIES_FAILURE,
  ACTION_EMPTY_AGENCIES,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function get(params?: any) {
  return (dispatch: Dispatch, getState: Function) => {
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'agencies',
        method: 'get',
        data: params || {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    dispatch(requestStarted());

    return null;
  };
}

export function emptyResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_AGENCIES,
      payload: null,
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_AGENCIES,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_AGENCIES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_AGENCIES_FAILURE,
    payload: responseJSON,
  };
}
